module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/luzern-cbd73bf41ec9a1d7b206479981beb0b5.png";